export const employeeImport = [
  {
    "First Name": "Julie",
    "Last Name": "Jimenez",
    Email: "julie.jimenez@example.com",
    Address: "4250 New Street",
    City: "Stevenage",
    Postcode: "EE32 3SE",
    Phone: "01754 13523",
    "Created At": "2022-11-10T17:56:18.353Z",
    "Updated At": "2022-11-10T18:32:15.298Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Senior"],
    "Start Date": "2015-02-12T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Mandy",
    "Last Name": "Clark",
    Email: "mandy.clark@example.com",
    Address: "8632 North Street",
    City: "Hereford",
    Postcode: "GT81 7DG",
    Phone: "016973 32814",
    "Created At": "2022-11-10T17:56:18.353Z",
    "Updated At": "2022-11-10T18:31:44.928Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Senior"],
    "Start Date": "2017-09-10T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Holly",
    "Last Name": "Carroll",
    Email: "holly.carroll@example.com",
    Address: "5976 Springfield Road",
    City: "Edinburgh",
    Postcode: "Y4 2LH",
    Phone: "016977 73053",
    "Created At": "2022-11-10T17:56:18.356Z",
    "Updated At": "2022-11-10T18:31:32.086Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Senior"],
    "Start Date": "2022-02-12T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Francis",
    "Last Name": "Castro",
    Email: "francis.castro@example.com",
    Address: "3970 High Street",
    City: "Wells",
    Postcode: "X12 6QA",
    Phone: "017684 23551",
    "Created At": "2022-11-10T17:56:18.357Z",
    "Updated At": "2022-11-10T18:31:16.976Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Apprentice"],
    "Start Date": "2021-03-10T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Richard",
    "Last Name": "Kelley",
    Email: "richard.kelley@example.com",
    Address: "2346 York Road",
    City: "Leicester",
    Postcode: "H7S 1AH",
    Phone: "013873 65167",
    "Created At": "2022-11-10T17:56:18.353Z",
    "Updated At": "2022-11-10T18:32:23.314Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Apprentice"],
    "Start Date": "2020-07-09T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Donald",
    "Last Name": "Lynch",
    Email: "donald.lynch@example.com",
    Address: "9642 New Road",
    City: "St Albans",
    Postcode: "V9A 1NP",
    Phone: "015242 46760",
    "Created At": "2022-11-10T17:56:18.352Z",
    "Updated At": "2022-11-10T18:30:38.439Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Junior"],
    "Start Date": "2018-04-13T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Maria",
    "Last Name": "Torres",
    Email: "maria.torres@example.com",
    Address: "9998 New Road",
    City: "Aberdeen",
    Postcode: "LP7 8JQ",
    Phone: "0101 472 3365",
    "Created At": "2022-11-10T17:56:18.353Z",
    "Updated At": "2022-11-10T18:31:37.748Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Manager"],
    "Start Date": "2016-05-22T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Suzy",
    "Last Name": "Ruiz",
    Email: "suzy.ruiz@example.com",
    Address: "4641 Victoria Street",
    City: "Armagh",
    Postcode: "MO4X 8BP",
    Phone: "015242 79977",
    "Created At": "2022-11-10T17:56:18.354Z",
    "Updated At": "2022-11-10T18:58:54.632Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Senior", "Manager"],
    "Start Date": "2019-05-01T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Patrick",
    "Last Name": "Garcia",
    Email: "patrick.garcia@example.com",
    Address: "7818 The Crescent",
    City: "Bath",
    Postcode: "OH5 3HE",
    Phone: "017683 02608",
    "Created At": "2022-11-10T17:56:18.353Z",
    "Updated At": "2022-11-10T18:31:06.820Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Apprentice"],
    "Start Date": "2014-08-30T12:00:00.000",
    "Badge Photo": [],
  },
  {
    "First Name": "Brayden",
    "Last Name": "Carpenter",
    Email: "brayden.carpenter@example.com",
    Address: "8755 The Drive",
    City: "Bradford",
    Postcode: "YH5 8RY",
    Phone: "015395 12426",
    "Created At": "2022-11-10T17:56:18.354Z",
    "Updated At": "2022-11-10T20:41:26.977Z",
    tableId: "ta_bb_employees",
    type: "row",
    "Employee Level": ["Contractor"],
    "Start Date": "2022-11-09T12:00:00.000",
    "Badge Photo": [],
  },
]
